import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const fetchImages = async (eventId) => {
    return apiWrapper({
      fetch,
      url: `events/event/images?eventId=${eventId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const uploadImages = async (eventId, files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('eventId', eventId);

    return apiWrapper({
      fetch,
      url: `file/upload`,
      options: {
        method: 'POST',
        body: formData
      }
    });
  }

  return {
    fetchImages,
    uploadImages
  }
}